import VoiceModel from 'src/models/Voice/VoiceModel';
import createDocumentResource from 'src/actions/shared/createDocumentResource';

const voiceConfigResource = createDocumentResource<VoiceModel>({
  name: 'voiceConfig',
  endpoint: 'v1/orgs/:orgId/configuration/voice',
  type: VoiceModel,
});

export default voiceConfigResource;
